"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    createElement: ()=>createElement,
    hasRenderFunction: ()=>hasRenderFunction
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactUtilities = require("@fluentui/react-utilities");
function createElement(type, props, ...children) {
    return hasRenderFunction(props) ? createElementFromRenderFunction(type, props, children) : /*#__PURE__*/ _react.createElement(type, props, ...children);
}
function createElementFromRenderFunction(type, props, overrideChildren) {
    const { [_reactUtilities.SLOT_RENDER_FUNCTION_SYMBOL]: renderFunction , ...renderProps } = props;
    if (overrideChildren.length > 0) {
        renderProps.children = /*#__PURE__*/ _react.createElement(_react.Fragment, {}, ...overrideChildren);
    }
    return /*#__PURE__*/ _react.createElement(_react.Fragment, {}, renderFunction(type, renderProps));
}
function hasRenderFunction(props) {
    return Boolean(props === null || props === void 0 ? void 0 : props.hasOwnProperty(_reactUtilities.SLOT_RENDER_FUNCTION_SYMBOL));
} //# sourceMappingURL=createElement.js.map

//# sourceMappingURL=createElement.js.map